
import { IncomeExpense } from "../../classes"

const IncomeExpenseModule = {
  namespaced: true,
  state: {
    incomeExpenses: null,
  },
  mutations: {
    setIncomeExpenses(state, incomeExpenses) {
      state.incomeExpenses = incomeExpenses || []
    },
    clearIncomeExpenses(state){
      state.incomeExpenses = null
    },
  },
  actions: {
    getIncomeExpenseBetweenDateByMarket: async ({ commit }, fromData) => {
      try{
        commit("clearIncomeExpenses")
        const data = await IncomeExpense.getIncomeExpenseBetweenDateByMarket(fromData)
        commit("setIncomeExpenses", data)
        return data
      }catch(error){
        throw error
      }
    },
  },
  getters: {
    getIncomeExpenses: (state) => state.incomeExpenses,
  },
};
export default IncomeExpenseModule;
